import { useShortcutContext } from '@/contexts/ShortcutContext'

function KeyBadge({ keyStr }: { keyStr: string }) {
  const isMac = typeof navigator !== 'undefined' && /mac/i.test(navigator.platform)
  const display = keyStr
    .replace(/Ctrl\+/gi, isMac ? '⌘' : 'Ctrl+')
    .replace(/Alt\+/gi, isMac ? '⌥' : 'Alt+')
    .replace(/Shift\+/gi, isMac ? '⇧' : 'Shift+')
  return (
    <kbd className="inline-flex items-center px-1.5 py-0.5 rounded border border-border bg-background text-[10px] font-mono text-muted-foreground dark:bg-muted dark:border-border dark:text-muted-foreground">
      {display}
    </kbd>
  )
}

export function ShortcutFooterBar() {
  const { shortcuts, toggleHelp } = useShortcutContext()
  const enPie = shortcuts.filter((s) => s.showInFooter)
  // El tope de 5 es para los atajos de la pantalla; los avisos de solo ayuda van
  // siempre, porque si no quedan recortados en las pantallas que ya llenan el pie.
  const footerShortcuts = [
    ...enPie.filter((s) => !s.soloAyuda).slice(0, 5),
    ...enPie.filter((s) => s.soloAyuda),
  ]

  if (footerShortcuts.length === 0) return null

  return (
    <div className="flex items-center gap-4 px-4 py-1.5 bg-muted dark:bg-card border-t border-border dark:border-border text-xs text-muted-foreground dark:text-muted-foreground shrink-0">
      {footerShortcuts.map((s) => (
        <span key={s.key} className="flex items-center gap-1.5">
          <KeyBadge keyStr={s.key} />
          <span>{s.label}</span>
        </span>
      ))}
      <span className="ml-auto flex items-center gap-1.5 cursor-pointer hover:text-foreground dark:hover:text-muted-foreground" onClick={toggleHelp}>
        <KeyBadge keyStr="?" />
        <span>Ayuda</span>
      </span>
    </div>
  )
}
